export const getDisplayDashboard = function(state) {
    return state.display_dashboard
}

export const getDisplayDashboard2019 = function(state) {
    return state.display_spacy
}

